import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-google-calendar',
    templateUrl: './google-calendar.component.html',
    standalone: false
})
export class GoogleCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
